import { COLUMN_COLORS, COLUMN_PICKER_COLORS, COLUMN_TO_BORDER_COLOR_MAP, COLUMN_TO_HIGHLIGHT_BORDER_COLOR_MAP, COLUMN_TO_HOVER_COLOR_MAP, COLUMN_TO_TAG_COLOR_MAP } from "../../constants/colorConstants";

/**
 * Task column data as stored in the database
 */
export interface TaskColumnData {
  id: string;
  topic_id: string;
  name: string;
  color: string;
  status: string; // Status ID used in TaskItem
  position: number;
  created_at: string;
  updated_at?: string;
  metadata?: {
    client_id?: string;
    created_at?: string;
    updated_at?: string;
    [key: string]: any;
  };
  isDeleted?: boolean; // Used for offline tracking only
}

/**
 * Formatted task column with additional derived properties
 */
export interface FormattedTaskColumn {
  id: string;
  topicId: string;
  name: string;
  color: string;
  status: string;
  position: number;
  createdAt: string;
  updatedAt?: string;
  borderColor: string;
  highlightBorderColor: string;
  hoverColor: string;
  tagColor: string;
}

/**
 * Input for creating a new task column
 */
export interface CreateTaskColumnInput {
  topicId: string;
  name?: string;
  color?: string;
  afterColumnId?: string; // Optional column ID to position after
}

/**
 * Input for updating a task column
 */
export interface UpdateTaskColumnInput {
  name?: string;
  color?: string;
}

/**
 * Input for reordering a task column
 */
export interface ReorderTaskColumnInput {
  topicId: string;
  columnId: string;
  newIndex: number;
}

/**
 * Helper function to format a task column from database format to UI format
 * @param column The raw task column data from the database
 * @returns A formatted task column with derived properties for UI
 */
export function formatTaskColumn(column: TaskColumnData): FormattedTaskColumn {
  return {
    id: column.id,
    topicId: column.topic_id,
    name: column.name,
    color: column.color,
    status: column.status,
    position: column.position,
    createdAt: column.created_at,
    updatedAt: column.updated_at,
    // Derived UI properties
    borderColor: COLUMN_TO_BORDER_COLOR_MAP[column.color] || 'border-gray-300',
    highlightBorderColor: COLUMN_TO_HIGHLIGHT_BORDER_COLOR_MAP[column.color] || 'border-gray-500',
    hoverColor: COLUMN_TO_HOVER_COLOR_MAP[column.color] || 'hover:bg-gray-50',
    tagColor: COLUMN_TO_TAG_COLOR_MAP[column.color] || 'bg-gray-100 text-gray-800 border border-gray-100',
  };
}

// Export color constants for reuse across components
export {
  COLUMN_COLORS,
  COLUMN_PICKER_COLORS,
  COLUMN_TO_BORDER_COLOR_MAP,
  COLUMN_TO_HIGHLIGHT_BORDER_COLOR_MAP,
  COLUMN_TO_HOVER_COLOR_MAP,
  COLUMN_TO_TAG_COLOR_MAP
};